import { contextFactory } from '@frontend/design-system';

export interface KioskHomeContextProps {
  locationId: string;
}

export const [KioskHomeContext, useKioskHomeContext] = contextFactory<KioskHomeContextProps>();
